<template>
  <!-- Standard 2 Column Layout -->
  <div class="mri-standard-content" :class="`year-${year}`">
    <div class="row">
      <div class="col-50">
        <div class="image-container t2-image">
          <img :src="require(`@/assets/img/brains/brain_${year}-1.png`)" :alt="data.img1AltText">
        </div>
          <div class="caption">
            <h3 v-if="data.img1Title" v-html="data.img1Title"/>
            <p class="img-caption" v-html="data.img1Caption"/>
          </div>
          
      </div>
      <div class="col-50">
        <div class="image-container t1-image">
          <img :src="require(`@/assets/img/brains/brain_${year}-2.png`)" :alt="data.img2AltText">
        </div>
          <div class="caption">
            <h3 v-if="data.img2Title" v-html="data.img2Title"/>
            <p class="img-caption" v-html="data.img2Caption"/>
          </div>
      </div>
    </div>
    <div class="row">
      <div class="col-30 image-container axial">
        <img src="../assets/img/axial-brain.png" alt="Brain model showing horizontal (axial) plane cut, to indicate axial MRI image." />
      </div>
      <div class="col-70">
        <h3 v-if="data.img3Title" v-html="data.img3Title"/>
        <p class="img-caption" v-html="data.img3Caption"/>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "MriDefaultContent",
  props: {
    year: {
      type: Number
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#mri-results-text {
  &.subtitle {
    position: relative;
    top: 0;
    right: auto;
    width: 80%;
  }
}

.mri-results.content {
  .row:first-child {
    margin-bottom: rem(30px);
  }

  .col-50, .col-30 {
    &:first-child {
      padding-right: rem(30px);
    }
  }

  @include breakpoint(xs) {
    .col-50, .col-30, .col-70 {
      width: 100%;
    }
  }

  @include breakpoint(s) {
    .col-50, .col-30, .col-70 {
      width: 100%;
    }
  }
}

.image-container {
  &.t2-image, &.t1-image {
    width: 250px;
  }
  &.axial {
    width: 200px;
  }
  img {
    width: 100%;
  }
}

.caption, .img-caption {
  margin-top: rem(15px);
}

.year-5, .year-9, .year-20 {
  .image-container {
    &.t2-image, &.t1-image {
      height: 345px;
      @include breakpoint(xs) {
        height: auto;
      }
    }
  }
}

.year-6 {
  .image-container {
    &.t2-image, &.t1-image {
      height: 275px;
      @include breakpoint(xs) {
        height: auto;
      }
    }
  }
}
</style>